import { Box, Flex, Menu, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type SuggestionDropdownProps = {
  label: string;
  bgColor: string;
  suggestions: Array<{
    key: string;
    textContent: string;
    scrollIntoView: () => void;
  }>;
  disabled?: boolean;
};

export default function SuggestionDropdown({
  label,
  bgColor,
  suggestions,
  disabled,
}: SuggestionDropdownProps) {
  const [opened, setOpened] = useState(false);
  const textColor = disabled ? 'gray.4' : 'black';

  useEffect(() => {
    setOpened(false);
  }, [disabled]);

  return (
    <Menu opened={opened} onChange={setOpened}>
      <Menu.Target>
        <Flex
          bg="white"
          h={28}
          py="xxxs"
          px="xxs"
          style={{
            borderRadius: 'var(--mantine-radius-xl)',
            cursor: disabled ? 'default' : 'pointer',
            pointerEvents: disabled ? 'none' : 'auto',
          }}
          align="center"
          gap="xxxs"
        >
          <Box p="xxxs">
            <Box h={12} w={12} bg={bgColor} style={{ borderRadius: '50%' }} />
          </Box>
          <Text size="sm" fw={FONT_WEIGHTS.medium} c={textColor} style={{ whiteSpace: 'nowrap' }}>
            {label}
          </Text>
          <IconChevronDown size={16} color={disabled ? 'var(--mantine-color-gray-4)' : 'black'} />
        </Flex>
      </Menu.Target>
      <Menu.Dropdown maw={350}>
        {suggestions.length === 0 ? (
          <Menu.Item disabled>No suggestions</Menu.Item>
        ) : (
          suggestions.map(suggestion => {
            const truncatedText =
              suggestion.textContent.length > 50
                ? `${suggestion.textContent.slice(0, 50)}...`
                : suggestion.textContent;
            return (
              <Menu.Item key={suggestion.key} onClick={() => suggestion.scrollIntoView()}>
                <Text size="sm" fw={FONT_WEIGHTS.medium} c="black">
                  {truncatedText}
                </Text>
              </Menu.Item>
            );
          })
        )}
      </Menu.Dropdown>
    </Menu>
  );
}
